import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatsOpen, setMobileCatsOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/80 backdrop-blur-md border-b border-background-200/60">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-xl font-semibold text-foreground-900">GTBuy Sheet</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
            <Link to="/" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Shopping Guide</Link>
            <a href={isHome ? "#categories" : "/#categories"} className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Categories</a>
            <a href={isHome ? "#comparison" : "/#comparison"} className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Compare</a>
            <a href={isHome ? "#articles" : "/#articles"} className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Articles</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line text-sm"></i></span>
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 flex flex-col gap-1 border-t border-background-200/60 pt-3">
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-foreground-900 py-2.5 px-1 whitespace-nowrap cursor-pointer">Home</Link>
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-foreground-900 py-2.5 px-1 whitespace-nowrap cursor-pointer">Shopping Guide</Link>
            <a href="/#categories" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-foreground-900 py-2.5 px-1 whitespace-nowrap cursor-pointer">Categories</a>
            <a href="/#comparison" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-foreground-900 py-2.5 px-1 whitespace-nowrap cursor-pointer">Compare</a>
            <a href="/#articles" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-foreground-900 py-2.5 px-1 whitespace-nowrap cursor-pointer">Articles</a>

            {/* Mobile category accordion */}
            <button
              onClick={() => setMobileCatsOpen(!mobileCatsOpen)}
              className="flex items-center justify-between text-sm font-medium text-foreground-700 hover:text-foreground-900 py-2.5 px-1 cursor-pointer"
            >
              <span>Shop Categories</span>
              <i className={`text-lg ${mobileCatsOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}></i>
            </button>
            {mobileCatsOpen && (
              <div className="pl-2 flex flex-col gap-1 max-h-60 overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileOpen(false)}
                    className="text-sm text-foreground-500 hover:text-foreground-700 py-2 px-1 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              Buy It Now
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}